module.exports = __webpack_public_path__ + "img/faf5cd1103beeda516bee08ec1980cc7.png";